import { render, staticRenderFns } from "./vettore.vue?vue&type=template&id=760fb492&"
import script from "./vettore.vue?vue&type=script&lang=js&"
export * from "./vettore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports